import script from "./departmentStaffSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./departmentStaffSelect.vue?vue&type=script&setup=true&lang=js"

import "./departmentStaffSelect.vue?vue&type=style&index=0&id=86a9163c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86a9163c"]])

export default __exports__